
import {defineComponent, onMounted, ref, ssrRef, useContext, useFetch, watch, getCurrentInstance} from '@nuxtjs/composition-api'
import anime from 'animejs'
import core from '~/core'
export default defineComponent({
    
    setup(props, ctx){
        const name = ref<string>(core.user.state.name.value);
        const discordid = ref<string>(core.user.state.discord.value.name);
        const opened = ref(false)
        
        let $config: any = null;
        try {
            const _ctx = useContext();
            $config = (_ctx as any).$config;
        } catch (e) {
            const inst: any = getCurrentInstance() && getCurrentInstance().proxy;
            $config = inst ? inst.$config : null;
        }
        const verNum = ref($config ? $config.APP_VERSION : undefined)
        // if (process.server) verNum.value = process.env;
        // const {fetch} = useFetch(async () => {
        //     verNum.value = process.env;
        //     console.log(process.env)
        // })
        // fetch()
        const toggleOpen = (value?) => {
            if(value && !opened.value){
                opened.value=true
            }
            requestAnimationFrame(() => {
                const el = <HTMLElement>document.querySelector('#my-member-card .member-card')
                const w = el.offsetWidth
                if(value || !opened.value){
                    opened.value=true
                    anime({
                        targets: '#my-member-card .member-card_close',
                        opacity: [0, 1],
                        duration: 300,
                        easing: 'easeInOutQuad',
                    })
                    anime({
                        targets: el,
                        width: [0, w],
                        easing: 'cubicBezier(0.94, 0.01, 0, 1.01)',
                        duration: 600,
                    })
                } else{
                    anime({
                        targets: '#my-member-card .member-card_close',
                        opacity: [1, 0],
                        duration: 300,
                        easing: 'easeInOutQuad',
                    })
                    anime({
                        targets: el,
                        width: [w, 0],
                        easing: 'cubicBezier(0.94, 0.01, 0, 1.01)',
                        duration: 800,
                        complete(){
                            opened.value=false
                        }
                    })
                }
            })
            
            
        }
        onMounted(( ) => {
            
            
        })

        const logout = async () => {
            const name = core.user.state.name.value
            try{
                await core.user.logout()
                opened.value=false 
                core.alerts.events.notification.emit({message: `Bye ${name}!`})
                setTimeout(() => {
                    ctx.root.$router.push('/login');
                }, 2000)
                
            } catch(err){
                console.error(err)
            }
            
        }
        return {
            name,
            opened,
            discordid,
            logout,
            toggleOpen,
            verNum,
        }
    }
})
